import { Button } from '@mui/material';
import { useAtomValue, useSetAtom } from 'jotai';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TaskAction } from '@kheops/graphql';
import useOpenable from '../../../hooks/useOpenable';
import ConfirmDialog from '../../../common/components/ConfirmDialog';
import useOrderActions from '../../../hooks/useOrderActions';
import { orderAtom, orderDeliveryDateAtom } from '../../state/state';

export default function OrderDenyDeliveryButton(): React.JSX.Element {
  const { t } = useTranslation(['common', 'order']);
  const order = useAtomValue(orderAtom);
  const setOrderDeliveryDate = useSetAtom(orderDeliveryDateAtom);
  const [triggerUpdate, setTriggerUpdate] = useState(false);
  const { open, isOpen, close } = useOpenable();
  const { updateOrder, isLoading } = useOrderActions({ orderReferenceId: order.reference_id, orderId: order.id });

  const handleClose = useCallback((confirmed: boolean) => {
    if (confirmed) {
      setOrderDeliveryDate(null);
      setTriggerUpdate(true);
    }

    close();
  }, []);

  // use this effect block to make sure that the updateOrder function is up to date
  // with the new order delivery date value.
  useEffect(() => {
    if (triggerUpdate) {
      setTriggerUpdate(false);
      updateOrder(TaskAction.Reject);
    }
  }, [triggerUpdate, updateOrder]);

  return (
    <>
      <ConfirmDialog
        open={isOpen}
        onClose={handleClose}
        confirmLabel={t('order:deny')}
        cancelLabel={t('common:cancel')}
        title={t('order:deny_delivery')}
        subTitle={t('order:deny_delivery_description')}
      />
      <Button
        variant="outlined"
        color="tertiary"
        onClick={open}
        loading={isLoading}
      >
        {t('order:deny_delivery')}
      </Button>
    </>
  );
}
